import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { TranslateLoader } from '@ngx-translate/core';
import { Inject, Injectable, InjectionToken } from '@angular/core';
export const UNAUTHENTICATED_URL = new InjectionToken<string>(
  'api/v2/Language/GetPreLoginTranslations?language=',
);
export const AUTHENTICATED_URL = new InjectionToken<string>(
  'api/v2/Language/GetTranslationsByDictionary?dictionaryId=52B54DAD-3FA6-426F-B261-D20244634057&language=',
);

@Injectable()
export class TranslationLoader implements TranslateLoader {
  private apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    @Inject(UNAUTHENTICATED_URL) private unauthenticatedUrl: string,
    @Inject(AUTHENTICATED_URL) private authenticatedUrl: string,
  ) {}

  /**
   * Gets the translations from the server
   */
  getTranslation(lang: string): Observable<Translations> {
    let url;

    if (this.cookieService.check('access_token')) {
      url = this.apiUrl + this.authenticatedUrl;
    } else {
      url = this.apiUrl + this.unauthenticatedUrl;
    }

    if (lang == '') {
      lang = 'en-US';
    }

    return this.http.get<Translations>(`${url}${lang}`);
  }
}

// Define an interface for the translations
interface Translations {
  [key: string]: string;
}
